import { useState } from 'react';

export function useToggle(initialState) {
	const [state, setState] = useState(initialState);
	const toggleState = () => setState((state) => !state);

	return [state, toggleState, setState];
}

export default useToggle;
